import styled from 'styled-components/macro'

import { type TagProps } from '@loadsmart/miranda-react'

import useWindowWidth from 'core/ui/hooks/useWindowWidth'

import { intSizes } from 'legacy/styles/screen'

import { type AgnosticShipment } from '../domain/AgnosticShipment'
import { ShipmentCardDesktop } from './ShipmentCardDesktop'
import { ShipmentCardMobile } from './ShipmentCardMobile'

const CardWrapper = styled.div`
  cursor: pointer;
`

export type ShipmentCardProps = {
  shipment: AgnosticShipment
  getActionLabel?: () => string | undefined
  getIdentifiers?: () => string[]
  getStatus?: () => {
    variant: TagProps['variant']
    label: string
  }
  onActionClick?: () => void
  onCardClick?: () => void
}

export function ShipmentCard(props: ShipmentCardProps) {
  const windowWidth = useWindowWidth()
  const isMobile = windowWidth <= intSizes.md

  let Component = ShipmentCardDesktop

  if (isMobile) {
    Component = ShipmentCardMobile
  } else {
    Component = ShipmentCardDesktop
  }

  return (
    <CardWrapper
      onClick={event => {
        const target = event.target as HTMLElement

        /**
         * This check was needed to prevent the card from being clicked when the accordion is toggled.
         * even.stopPropagation() on the accordion toogle was not working, so we need to check the tag name.
         */
        if (target.tagName === 'M-ACCORDION-TITLE' || target.tagName === 'M-ACCORDION') {
          return
        }

        props.onCardClick?.()
      }}
      data-testid="agnostic-shipment-card"
    >
      <Component {...props} />
    </CardWrapper>
  )
}
